import Vue from 'vue'
import feather from 'vue-icon'

Vue.use(feather, 'v-icon')
